// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__RxrVj","rela":"styles_rela__U7nH8","open":"styles_open__5PxxX"};